import React, {Component} from 'react';
import {ModalBody, ModalFooter} from 'reactstrap';
import {APIClient} from "../../../utils/APIClient";
import {API_URL} from "../../../settings/local_settings";
import {Spinner} from "../../Spinner";
import {
    CHANNEL_STORE_SELECT_SPECIAL_ITEMS,
    ChannelStoreSelect,
    SPECIAL_ITEM_CONNECT_NEW_STORE
} from "../../selects/ChannelStoreSelect";
import {ClientSelect} from "../../selects/ClientSelect";
import {AddStoreModal} from "../../channels/shopify/AddStoreModal";
import {AddTiendaNubeStoreModal} from "../../channels/tienda_nube/AddTiendaNubeStoreModal";
import {AddWooCommerceStoreModal} from "../../channels/woocommerce/AddWooCommerceStoreModal";
import {AddVtexStoreModal} from "../../channels/vtex/AddVtexStoreModal";
import {CHANNEL_INFO_BY_CHANNEL, CHANNEL_TYPE_ECOMMERCE, SHOPIFY_CHANNEL, TIENDA_NUBE_CHANNEL, WOOCOMMERCE_CHANNEL, VTEX_CHANNEL} from "../../channels/channels";
import { withTranslation } from 'react-i18next';
import {toast} from 'react-toastify';
import {isPlanLimitError, publishAdAccountQuota, quotaFromLinkError, refetchAdAccountQuota} from "../../../utils/adAccountQuota";
import {planLimitText} from "../control_central/accountQuota";
import {AccountQuotaGate} from "../control_central/AccountQuotaGate";

// La pantalla en los eventos del cupo (`account_quota_shown_store`, …). Una tienda cuenta para el cupo de
// cuentas del plan igual que una cuenta publicitaria (`SubscriptionService.ad_account_quota`).
const QUOTA_SURFACE = 'store';

export class AddClientStoreFormClass extends Component {

    constructor(props) {
        super(props);

        const storeIsAlreadySelected = (this.props.channel !== undefined && this.props.storeId !== undefined);
        const selectedStore = this.props.storeId !== undefined ? this.props.storeId : null;
        const channel = this.props.channel !== undefined ? this.props.channel : SHOPIFY_CHANNEL;

        this.state = {
            ...this.state,
            creatingClientStore: false,
            allShopifyStores: null,
            allTiendaNubeStores: null,
            allWooCommerceStores: null,
            allVtexStores: null,
            agencyChannels: null,
            channel: channel,
            storeIsAlreadySelected: storeIsAlreadySelected,
            selectedStore: selectedStore,
            selectedClient: null,
            agencyClients: null,
            hasClickedOnSubmit: false
        };

        this.handleSelectedChannelChange = this.handleSelectedChannelChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleStoreChange = this.handleStoreChange.bind(this);
        this.handleClientChange = this.handleClientChange.bind(this);
        this.afterSuccessfulStoreSubmit = this.afterSuccessfulStoreSubmit.bind(this);
        this.footerButton = this.footerButton.bind(this);
    }

    componentDidMount() {

        this.getActiveAgencyClients();

        if(!this.state.storeIsAlreadySelected) {
            this.getAllStores();
            this.getAgencyChannels();
        }
    }

    // API

    getAgencyChannels(){
        new APIClient(this.getAgencyChannelsURL()).call('GET').then((response) => {
            if (response.status !== 'OK') {
                this.notifyLoadError();
                this.setState({
                    agencyChannels: []
                })
            } else {
                const newState = {
                    agencyChannels: response.data
                };
                if (this.props.channel === undefined && response.data.length > 0) {
                    newState.channel = response.data[0];
                }
                this.setState(newState);
            }
        });
    }

    getAllStores() {
        this.getAdAccountsForChannel(SHOPIFY_CHANNEL, (stores) => {
            this.setState({
                allShopifyStores: stores
            })
        });
        this.getAdAccountsForChannel(TIENDA_NUBE_CHANNEL, (stores) => {
            this.setState({
                allTiendaNubeStores: stores
            })
        });
        this.getAdAccountsForChannel(WOOCOMMERCE_CHANNEL, (stores) => {
            this.setState({
                allWooCommerceStores: stores
            })
        });
        this.getAdAccountsForChannel(VTEX_CHANNEL, (stores) => {
            this.setState({
                allVtexStores: stores
            })
        });
    }

    getActiveAgencyClients() {
        new APIClient(this.getActiveAgencyClientsURL()).call('GET').then((response) => {
            if (response.status !== 'OK') {
                this.notifyLoadError();
                this.setState({
                    agencyClients: []
                })
            } else {
                this.setState({
                    agencyClients: response.data
                })
            }
        });
    }

    getAdAccountsForChannel(channel, callback) {
        new APIClient(this.getAdAccountsForChannelURL(channel)).call('GET').then((response) => {
            if (response.status !== 'OK') {
                this.notifyLoadError();
                callback([]);
            } else {
                callback(response.data)
            }
        });
    }

    // Genérico y por toast, no con el `alert` del mensaje crudo: el alert bloquea la pantalla y el
    // texto del backend puede nombrar otra agencia («esa tienda ya está conectada a…»). Con cuatro
    // pedidos en paralelo al abrir, el `toastId` fijo evita cuatro carteles iguales.
    notifyLoadError() {
        toast.error(this.props.t('add_client_store_form.load_error'), {toastId: 'add-client-store-load-error'});
    }

    // El tope del plan no se resuelve reintentando (UD-15): con los números del rechazo, el aviso del cupo
    // lleno reemplaza al formulario (sin un toast que lo repita); sin ellos, el toast lo dice igual. El resto,
    // genérico: el `error_message` puede nombrar otra agencia.
    notifySaveError(response) {
        if (isPlanLimitError(response)) {
            const quota = quotaFromLinkError(response);
            if (quota) {
                publishAdAccountQuota(quota);
            } else {
                toast.error(planLimitText(this.props.t, null));
                refetchAdAccountQuota();
            }
            return;
        }
        toast.error(this.props.t('add_client_store_form.save_error'));
    }

    getClientId() {
        return this.props.clientId ? this.props.clientId : this.state.selectedClient
    }


    handleSubmit(event) {
        event.preventDefault();

        // El error lo muestra el componente. Se entera porque se le pasa el hasClickedOnSubmit
        if(this.state.selectedStore === null || CHANNEL_STORE_SELECT_SPECIAL_ITEMS.includes(this.state.selectedStore))
        {
            this.setState({hasClickedOnSubmit: true});
            return;
        }

        this.setState({
            creatingClientStore: true,
        });

        new APIClient(this.submitUrl()).call('POST', this.getDataToPost(event)).then((data) => {
            this.setState({
                creatingClientStore: false
            });

            if (data.status !== 'OK') {
                this.notifySaveError(data);
            } else {
                refetchAdAccountQuota();
                this.props.afterSuccessfulSubmit(data.data.agency_client_store_id)
            }
        });
    }

    getDataToPost(event) {

        const channel = this.state.storeIsAlreadySelected === true ? this.state.channel : event.target.campaignChannel.value;
        const adAccountId = this.state.selectedStore;

        return {
            'client_id': this.getClientId(),
            'account_id': adAccountId,
            'channel': channel
        };
    }

    handleSelectedChannelChange(event) {
        event.preventDefault();
        this.setState({
            channel: event.target.value,
            selectedStore: null
        });
    }

    handleStoreChange(adAccountId, storeName) {
        // Si selecciono "NUEVA CUENTA". Segun el canal seleccionado se muestra el modal de creacion de cuenta correspondiente
        if (this.state.channel === SHOPIFY_CHANNEL && adAccountId === SPECIAL_ITEM_CONNECT_NEW_STORE) {
            this.addShopifyStoreModal.toggle();
        }

        if (this.state.channel === TIENDA_NUBE_CHANNEL && adAccountId === SPECIAL_ITEM_CONNECT_NEW_STORE) {
            this.addTiendaNubeStoreModal.toggle();
        }

        if (this.state.channel === WOOCOMMERCE_CHANNEL && adAccountId === SPECIAL_ITEM_CONNECT_NEW_STORE) {
            this.addWooCommerceStoreModal.toggle();
        }

        if (this.state.channel === VTEX_CHANNEL && adAccountId === SPECIAL_ITEM_CONNECT_NEW_STORE) {
            this.addVtexStoreModal.toggle();
        }

        this.setState({
            selectedStore: adAccountId
        })
    }

    handleClientChange(clientId, clientName) {
        this.setState({
            selectedClient: clientId
        })
    }

    footerButton() {
        const { t } = this.props;
        if (this.state.creatingClientStore) {
            return <Spinner color="positive small"/>
        } else {
            return <input type="submit" value={t('add_client_store_form.add')} className="btn -submit"/>
        }
    }

    addingStoreForAPredefinedClient() {
        return typeof this.props.clientId !== 'undefined' && this.props.clientId > 0;
    }

    renderClientInput() {
        if (this.addingStoreForAPredefinedClient()) {
            return (<input name="client" type="text" value={this.props.clientName} readOnly="readonly"
                           className="form-control form-control-plaintext pl-3"/>)
        } else {
            return (<ClientSelect selectedOption={this.state.selectedClient}
                                  allClients={this.state.agencyClients}
                                  onClientChange={this.handleClientChange}
                                  required={true}
            />)
        }
    }

    renderChannelsSelect() {
        const { t } = this.props;
        if(this.state.agencyChannels === null)
            return <p>{t('common.loading')}</p>

        return <select name="campaignChannel" value={this.state.channel} onChange={this.handleSelectedChannelChange} required="required" className="form-control">
            {this.state.agencyChannels.map((option) => <option key={option} value={option}>{CHANNEL_INFO_BY_CHANNEL[option]?.Spanish || option}</option>)}
        </select>
    }

    renderNewStoreModals() {
        return (
            <>
                {/* El cliente viaja para el pedido del link de instalación de Shopify (con el flag): así la
                    tienda queda pedida para él. El alta por OAuth no lo usa. */}
                <AddStoreModal ref={instance => {
                    this.addShopifyStoreModal = instance;
                }}
                                          clientId={this.getClientId() || undefined}
                                          afterSuccessfulSubmit={this.afterSuccessfulStoreSubmit}/>
                <AddTiendaNubeStoreModal ref={instance => {
                    this.addTiendaNubeStoreModal = instance;
                }}
                                          afterSuccessfulSubmit={this.afterSuccessfulStoreSubmit}/>
                <AddWooCommerceStoreModal ref={instance => {
                    this.addWooCommerceStoreModal = instance;
                }}
                                          afterSuccessfulSubmit={this.afterSuccessfulStoreSubmit}/>
                <AddVtexStoreModal ref={instance => {
                    this.addVtexStoreModal = instance;
                }}
                                          afterSuccessfulSubmit={this.afterSuccessfulStoreSubmit}/>
            </>
        )
    }

    storesStateKeyOfChannel(channel) {
        if (channel === SHOPIFY_CHANNEL) return 'allShopifyStores';
        if (channel === WOOCOMMERCE_CHANNEL) return 'allWooCommerceStores';
        if (channel === VTEX_CHANNEL) return 'allVtexStores';
        return 'allTiendaNubeStores';
    }

    // Si la conexión no devolvió los datos de la tienda, la pedimos al server en vez de dejar
    // el selector desactualizado (antes rompía con un TypeError y sólo un F5 mostraba la tienda).
    reloadStoresOfChannel(channel) {
        this.getAdAccountsForChannel(channel, (stores) => {
            this.setState({[this.storesStateKeyOfChannel(channel)]: stores});
        });
    }

    afterSuccessfulStoreSubmit(newStoreData) {
        const channel = this.state.channel;

        if (!newStoreData || !newStoreData.store_id) {
            this.reloadStoresOfChannel(channel);
            return;
        }

        const allStores = this.state[this.storesStateKeyOfChannel(channel)] || [];

        const data = {
            'id': newStoreData.store_id,
            'name': newStoreData.name,
            'name_with_parents': newStoreData.name,
            'currency_code': newStoreData.currency
        };

        // Array nuevo (no push sobre el del state) para que el select vea una referencia distinta.
        this.setState({
            [this.storesStateKeyOfChannel(channel)]: [...allStores, data],
            selectedStore: newStoreData.store_id
        });
    }

    render() {
        return <AccountQuotaGate surface={QUOTA_SURFACE}>
            {(quotaNotice) => this.renderContent(quotaNotice)}
        </AccountQuotaGate>;
    }

    renderContent(quotaNotice) {
        // Con el cupo lleno, cualquier tienda que se elija va a rebotar: el aviso, con sus dos salidas, en
        // lugar del formulario.
        if (quotaNotice) {
            return <ModalBody>{quotaNotice}</ModalBody>;
        }

        const { t } = this.props;
        return [
            <form key="form" onSubmit={this.handleSubmit}>
                <ModalBody>
                    <div className="modal-section">
                        <div className="form-row">
                            <div className="form-col">
                                <label>{t('add_client_store_form.client')}</label>
                                {this.renderClientInput()}
                            </div>
                            <div className="form-col">
                                &nbsp;
                            </div>
                        </div>
                        {this.renderSelectStoreSection()}
                    </div>
                </ModalBody>
                <ModalFooter>
                    {this.footerButton()}
                </ModalFooter>
            </form>,
            <React.Fragment key="new-store-modals">{this.renderNewStoreModals()}</React.Fragment>
        ];
    }

    renderSelectStoreSection() {
        const { t } = this.props;
        if(this.state.storeIsAlreadySelected)
            return;

        return <div className="form-group" id="account_selector_group">
            <label className="separator">{t('add_client_store_form.ecommerce_store')}</label>
            <div className="form-row">
                <div className="form-col">
                    <label>{t('add_client_store_form.type')}</label>
                    {this.renderChannelsSelect()}
                </div>
                <div className="form-col">
                    <label>{t('add_client_store_form.store')}</label>
                    <ChannelStoreSelect channel={this.state.channel}
                                        selectedStore={this.state.selectedStore}
                                        allStores={this.allAdAccountsOfChannel(this.state.channel)}
                                        onStoreChange={this.handleStoreChange}
                                        canCreateNewStore={true}
                                        showFormValidationTexts={this.state.hasClickedOnSubmit}
                    />
                </div>
            </div>
        </div>;
    }

    // aux

    allAdAccountsOfChannel(channel) {
        if (channel === SHOPIFY_CHANNEL) {
            return this.state.allShopifyStores
        }
        if (channel === TIENDA_NUBE_CHANNEL) {
            return this.state.allTiendaNubeStores
        }
        if (channel === WOOCOMMERCE_CHANNEL) {
            return this.state.allWooCommerceStores
        }
        if (channel === VTEX_CHANNEL) {
            return this.state.allVtexStores
        }
    }

    // URLS

    getAgencyChannelsURL() {
        return `${API_URL}get-channels/${CHANNEL_TYPE_ECOMMERCE}/`
    }

    getAdAccountsForChannelURL(channel) {
        return `${API_URL}get-accounts/${channel}`
    }

    getActiveAgencyClientsURL() {
        return `${API_URL}agency/clients/active`
    }

    submitUrl() {
        return API_URL + 'client/' + this.getClientId() + '/ad_account/add';
    }
}

export const AddClientStoreForm = withTranslation()(AddClientStoreFormClass);
export default AddClientStoreForm;
